import React from 'react';
import {Jumbotron} from "./Components/Jumbotron";

export const About = () => (
	<>
		<h1>About Page</h1>
		<Jumbotron/>
	</>
);